import { PlacementEntityIdentifierEnum } from '@local/typedefs/dist/common/placements';
export var PlacementEntityEnum;
(function (PlacementEntityEnum) {
    PlacementEntityEnum["PRODUCT"] = "product";
})(PlacementEntityEnum || (PlacementEntityEnum = {}));
export const CampaignPlacementsInfo = {
    [PlacementEntityEnum.PRODUCT]: [
        {
            placementId: PlacementEntityIdentifierEnum.SEARCH_KBA,
            adUnitType: 'PRODUCT',
            label: 'Search KBA',
        },
    ],
};
